import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=04c9c7b8&scoped=true&"
import script from "./section-title.vue?vue&type=script&lang=js&"
export * from "./section-title.vue?vue&type=script&lang=js&"
import style0 from "./section-title.vue?vue&type=style&index=0&id=04c9c7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9c7b8",
  null
  
)

export default component.exports